<template>
        <v-menu offset-y
                transition="slide-y-transition"
                bottom
        >
            <template v-slot:activator="{ on }">
                <span
                        style="user-select: none;cursor: pointer"
                        :class="{ 'nav-active':$route.path === '/international' || $route.path === '/country'}"
                        v-on="on"
                >
<!--                    ดัชนีเศรษฐกิจสร้างสรรค์-->
                </span>
            </template>

            <v-list>
                <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                        @click="$router.push('/' + item.name)"
                >
                    <v-list-item-title class="navtxt" :class="{ 'nav-active':$route.path === '/' + item.name}">{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
</template>

<script>
    export default {
        name: 'IndicatorMenu',
        data: () => ({
            items: [
                { title: 'International' ,name: 'international'},
                { title: 'Country', name: 'country' }
            ],
        }),
    }
</script>

<style scoped lang="scss">
    .navtxt {
        font-size: 18px;
        font-weight: bold;
        text-transform: uppercase;
        color: #ff5100;
    }
    .nav-active {
        color: #000 !important;
        cursor: unset !important;
    }
    .navtxt span:not(.nav-active):hover {
        opacity: 0.75;
    }
</style>
